// extracted by mini-css-extract-plugin
export default {"root":"customerProfileShimmer_root__qzAdB","profile_top":"customerProfileShimmer_profile_top__Bsfix","table_content":"customerProfileShimmer_table_content__FW9gt"};